import {
  useCompanyDeleteMutation,
  useCompanyRestoreMutation,
} from '~hooks/query/admin/useCompanyPreference';
import useGetCompanyStates from '~hooks/query/company/useCompanyStates';
import { useRouterQuery } from '~hooks/useRouterQuery';

import ButtonAdmin from '../ButtonAdmin';
import Row from '../Row';
import { cssButton } from './style';

export default function RowDelete() {
  const companyId = useRouterQuery('companyId');
  const { data: companyStates } = useGetCompanyStates(companyId);
  const { mutate: handleDelete } = useCompanyDeleteMutation();
  const { mutate: handleRestore } = useCompanyRestoreMutation();

  const handleClickDelete = () => {
    if (window.confirm('이 기업을 정말 삭제하시겠습니까?')) {
      handleDelete();
    }
  };

  return (
    <Row title='기업 삭제'>
      <ButtonAdmin
        onClick={handleClickDelete}
        disabled={companyStates?.deleted}
        inlineCss={cssButton}>
        삭제하기
      </ButtonAdmin>
      <ButtonAdmin onClick={() => handleRestore()} disabled={!companyStates?.deleted}>
        복원하기
      </ButtonAdmin>
    </Row>
  );
}
